import React from "react";
import PublicFooter from "../PublicRouteLayouts/PublicFooter";

export default function PrivateFooter() {
  return (
    <div>
      <PublicFooter />
    </div>
  );
}
